export enum AnexoTipo {
  ARQUIVO = 'ARQUIVO',
}
